import { Box, Button, ButtonGroup, Container, Typography } from '@mui/material'
import React from 'react'
import { BsMoonStarsFill, BsSunFill, BsGithub } from 'react-icons/bs'
const Header = ({ isLight, setLightTheme }) => {
    return (
        <header>
            <Container maxWidth='lg' sx={{ display: 'flex', p: 2 }}>
                <Typography variant='h5' sx={{ flexGrow: '1' }}>
                    Fun with AI
                </Typography>
                <ButtonGroup color='warning' variant='text'>
                    <Button
                    aria-label='change theme button'
                        sx={{ fontSize: '1.5rem' }}
                        onClick={() => {
                            setLightTheme(state => !state)
                        }}
                    >
                        {isLight ? <BsMoonStarsFill alt='change theme' /> : <BsSunFill alt='change theme' />}
                    </Button>
                    <Button href='https://github.com/PatrickValera/22_shopify-intern-challenge'
                    aria-label='link to github'
                    sx={{ fontSize: '1.5rem' }}
                    ><BsGithub alt='github source code' /></Button>
                </ButtonGroup>
            </Container>
        </header>
    )
}

export default Header